<template>
  <div id="app">
    <div class="l-wrapper">
      <div class="l-menu" v-bind:class="{ 'close-menu': close }" @mouseover="openHover">
        <component-header :close="close"></component-header>
        <component-menu :close="close"></component-menu>
      </div>
      <div class="l-content" v-bind:class="{ 'close-content': close }" @mouseover="closeHover">
        <template v-if="login.state == false">
          <login-modal></login-modal>
        </template>
        <component-topnavi :close="close"></component-topnavi>
        <router-view class="view" keep-alive></router-view>
        <!-- <keep&#45;alive> -->
        <!--   <router&#45;view></router&#45;view> -->
        <!-- </keep&#45;alive> -->
        <component-footer :close="close"></component-footer>
      </div>
    </div>
  </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
@import "../node_modules/normalize.css/normalize.css";

* {
  box-sizing: border-box;
}
html {
  /*root擬似クラスが効かないのでhtmlタグに変数を設定する*/
  --color-primary: #263238;
  /* --color-primary: #e362e3; */
  /* --color-point:   #37474F; */
  --color-point:   #37474F;
  /* --color-menu:   #f3f7fa; */
  --color-menu:   #37474F;
  --color-bg:   #fbfbfb;
  --color-border:   #ccc;
  font-size: 13px;
}
body {
  margin:0;
  font-family: 'Noto Sans JP', sans-serif;
  padding-top: 45px;
  padding-bottom: 35px;
}
// scrollbar
::-webkit-scrollbar {
    width: 5px;
    height: 10px;
}
::-webkit-scrollbar-track {
  border-radius: 0px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, .1);
}
::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 50, .3);
  border-radius: 0px;
  box-shadow:0 0 0 1px rgba(255, 255, 255, .3);
}
button {
  border-radius: 0;
}
input ,textarea {
  font-size: .85rem;
  padding: .5em;
  &::-webkit-input-placeholder {
    color: #ccc;
  }
  &:-ms-input-placeholder {
    color: #ccc;
  }
  &::-moz-placeholder {
    color: #ccc;
  }
}
a {
  color: #333
}
.logo {
  width: 100px;
  height: 100px
}
.l-menu {
  width: 220px;
  position: fixed;
  top: 0;
  left: 0;
  background: var(--color-menu);
  min-height: 100vh;
  transition: all 600ms cubic-bezier(0.86, 0, 0.07, 1);
  overflow: hidden;
}
.close-menu {
  width: 52px;
}
.l-content {
  padding-left: 230px;
  padding-right: 10px;
  padding-top: 10px;
  transition: all 600ms cubic-bezier(0.86, 0, 0.07, 1);
}
.close-content {
  padding-left: 62px;
  padding-right: 10px;
  padding-top: 10px;
}
.m-label {
  padding: .5em;
  text-align: left;
  font-weight: normal;
  background-color: #f4f4f4;
  border-bottom: 2px solid var(--color-border);
  font-size: 1rem;
  position: relative;
  &:after {
    content: "";
    position: absolute;
    bottom: -2px;
    left: 0;
    display: block;
    width: 6rem;
    height: 2px;
    background: var(--color-primary);
  }
}
.m-name {
  font-size: 20px;
}
.m-table {
  th {
    text-align: left;
  }
}
.expand-transition {
  transition: all .5s ease-in-out;
  /*height: 30px;*/
  overflow: hidden;
}
/* .expand-enter は entering に対する開始状態を定義 */
/* .expand-leave は leaving に対する終了状態を定義 */
.expand-enter, .expand-leave {
  height: 0;
  /*padding: 0 10px;*/
  opacity: 0;
}

.multiselect__tags {
  padding: 8px 40px 0 2px;
}
.multiselect__input {
  font-size: 12px;
  &::-webkit-input-placeholder {
    color: #ccc;
  }
}
.multiselect__single {
  font-size: 12px;
}
.multiselect__content {
  font-size: 12px;
}

.vdp-datepicker {
  input {
    width: 100%;
    height: 100%;
    &::-webkit-input-placeholder {
      color: #ccc;
    }
  }
}
.vdp-datepicker__calendar {
  font-size: 17px;
  header {
    .prev {

    }
    .up {
      color: #000;
    }
    .next {

    }
  }
  .day-header {
    color: #42a5f7;
  }
  .selected {
    color: #fff;
    &:hover {
      color: #fff;
    }
  }
}

// fade-in
.loading-leave-active {
  transition: opacity 0s;
  opacity: 0;
}
.loading-enter-active /* .fade-leave-active below version 2.1.8 */ {
  transition: opacity .3s;
}

@media print {
  body {
    padding: 0 !important;
  }
  /* .is-print-none, .l-menu, .m-nav, footer, m-secNavi { */
  .is-print-none, .l-menu, footer, #Smallchat {
    display: none !important;
  }
  .m-nav {
    height: 0 !important;
    .m-nav__back, h1 {
      display: none;
    }
    .m-nav__action {
      position: absolute;
      top: -15px;
      right: 0;
      .delete, .logout, .type {
        display: none;
      }
    }
  }
  .l-content {
    padding: 0 !important;
  }
  .is-print-overflow {
    overflow: initial !important;
    height: initial !important;
  }
}
</style>

<script>
import store from '@/store/index.js'
import * as VueGoogleMaps from 'vue2-google-maps'
import Vue from 'vue'
import Editor from 'vue-html5-editor'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCrtvovqd2wcsQ2kmd3RSjN9yJq1vun5eA',
    v: '3.36',
    libraries: 'places'
  }
})

Vue.use(Editor, {
  // global component name
  name: 'vue-html5-editor',
  // custom icon class of built-in modules,default using font-awesome
  icons: {
    text: 'fa fa-pencil',
    color: 'fa fa-paint-brush',
    font: 'fa fa-font',
    align: 'fa fa-align-justify',
    list: 'fa fa-list',
    link: 'fa fa-chain',
    unlink: 'fa fa-chain-broken',
    tabulation: 'fa fa-table',
    image: 'fa fa-file-image-o',
    hr: 'fa fa-minus',
    eraser: 'fa fa-eraser',
    undo: 'fa-undo fa',
    'full-screen': 'fa fa-arrows-alt',
    info: 'fa fa-info'
  },
  // config image module
  image: {
    // Url of the server-side,default null and convert image to base64
    // return json data like  {ok:false,msg:"unexpected"} or {ok:true,data:"image url"}
    server: null,
    // the name for file field in multipart request
    fieldName: 'image',
    // max file size
    sizeLimit: 512 * 1024,
    // default true,if set to true,the image will resize by localResizeIMG (https://github.com/think2011/localResizeIMG)
    compress: true,
    // follows are options of localResizeIMG
    width: 1600,
    height: 1600,
    quality: 80
  },
  // default en-us, en-us and zh-cn are built-in
  language: 'ja',
  i18n: {
    // specify your language here
    'ja': {
      'align': 'アラインメント',
      'image': '画像',
      'list': 'リスト',
      'link': 'リンク',
      'unlink': 'リンクの削除',
      'table': '表',
      'font': '文字',
      'full screen': '全画面',
      'text': 'テキスト',
      'eraser': '消しゴム',
      'info': '情報',
      'color': 'カラー',
      'please enter a url': 'URLを入力して下さい',
      'create link': 'リンクの作成',
      'bold': '太字',
      'italic': '斜め文字',
      'underline': '下線',
      'strike through': '打ち消し線',
      'subscript': '上付き文字',
      'superscript': '下付き文字',
      'heading': '見出し',
      'font name': 'フォント名',
      'font size': '文字サイズ',
      'left justify': '左揃え',
      'center justify': '中央揃え',
      'right justify': '右揃え',
      'ordered list': '数字リスト',
      'unordered list': '点リスト',
      'fore color': '文字色',
      'background color': '背景色',
      'row count': '行数',
      'column count': '列数',
      'save': '保存',
      'upload': 'アップロード',
      'progress': '推移',
      'unknown': '不明なエラー',
      'please wait': 'お待ち下さい',
      'error': 'エラー',
      'abort': '中断',
      'reset': 'リセット'
    }
  },
  hiddenModules: [],
    // keep only the modules you want and customize the order.
    // can be used with hiddenModules together
  visibleModules: [
    'text',
    'color',
    'font',
    'align',
    'list',
    'link',
    'unlink',
    'tabulation',
    // 'image',
    'hr',
    'eraser',
    'undo',
    'full-screen'
    // 'info'
  ],
  // extended modules
  modules: {
    // omit,reference to source code of build-in modules
  }
})

export default {
  data () {
    return {
      // colors: [
      //   '#000000', '#000033', '#000066', '#000099', '#003300', '#003333', '#003366',
      //   '#003399', '#006600', '#006633', '#009900', '#330000', '#330033', '#330066',
      //   '#333300', '#333366', '#660000', '#660033', '#663300', '#666600', '#666633',
      //   '#666666', '#666699', '#990000', '#990033', '#9900CC', '#996600', '#FFCC00',
      //   '#FFCCCC', '#FFCC99', '#FFFF00', '#FF9900', '#CCFFCC', '#CCFFFF', '#FF0000'
      // ],
      close: true,
      dtp: {
        // date: '',
        // date: new Date()
        format: 'yyyy/MM/dd',
        disabled: {
          to: new Date()
          // from: new Date()
          // days: [6, 0]
          // dates: [
          //   new Date(2016, 9, 16),
          //   new Date(2016, 9, 17),
          //   new Date(2016, 9, 18)
          // ]
        }
      }
    }
  },
  computed: {
    login () {
      return this.$store.state.login
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getUser()
    })
  },
  watch: {
  },
  methods: {
    getUser () {
      this.$store.dispatch('getUser')
    },

    switchV: function () {
      this.close = !this.close
      // this[col] = !this[col]
    },

    openHover: function () {
      this.close = false
    },

    closeHover: function () {
      this.close = true
    }
  },
  store,
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// App.vue?45dbd9aa